import { get, post } from "../Http";
import { financeBasicLv, financeBasicQzc } from "../config";
//枚举类型
function findByCategoryId(params) {
    return post(`/${financeBasicLv}/basicenum/findByCategoryId`, params)
}
function saveAccount(params) {
    return post(`/${financeBasicLv}/basicaccountbook/save`, params)
}
function deleteAccount(params) {
    return post(`/${financeBasicLv}/basicaccountbook/delete`, params)
}
function listAccount(params) {
    return post(`/${financeBasicLv}/basicaccountbook/list`, params)
}
// 根据不同系统查询账套列表列表
function findListBySys(params) {
    return post(`/${financeBasicLv}/basicaccountbook/findListBySys`, params)
}
// 根据不同系统查询账套列表列表 不分页
function queryAllListBySys(params) {
  return post(`/${financeBasicLv}/basicaccountbook/queryAllListBySys`, params)
}
// 切换系统时查询账套是否拥有系统权限
function abCheck(params) {
  return post(`/${financeBasicLv}/basicaccountbook/abCheck`, params)
}

function allAccount(params) {
    return post(`/${financeBasicLv}/basicaccountbook/listAll`, params)
}
//查询机构下的账套
function accountSelect(params) {
    return post(`/${financeBasicLv}/basicaccountbook/queryAll`, params)

}
function queryAllByOrgId(params) {
    return post(`/${financeBasicLv}/basicaccountbook/queryAllByOrgId`, params)

}
function deleteSaveAccount(params) {
    return post(`/api-sys/sysuser/users/delsettings`, params)

}


//所属行业
function basictradeList(params) {
    return post(`/${financeBasicLv}/basictrade/list`, params)
}
//所属行业 根据上级id
function listTradeByParentId(params) {
    return post(`/${financeBasicLv}/basictrade/listTradeByParentId`, params)
}
//查询机构列表、
function orgList(params) {
    return post(`/api-sys/sysorganization/findOrgListByUser`, params)
}
//功能模块配置 列表
function accountServiceList() {
    return post(`/${financeBasicLv}/basicaccountbookservice/getByAbId`, {})
}

//查询省

function proviceList(params) {
    return post(`/${financeBasicLv}/basiccity/getProviceList`, params)
}

//查询市
//查询区/ 县
function cityList(params) {
    return post(`/${financeBasicLv}/basiccity/getByParentId`, params)
}
//获取所以枚举列表
function getAllEnumeration() {
    return post(`/${financeBasicQzc}/basicenum/findAll`)
}
function settingAccount(params) {
    return post(`/api-sys/sysuser/users/settings`, params)
}






export default {
    findByCategoryId,
    saveAccount,
    deleteAccount,
    listAccount,
    findListBySys,
    queryAllListBySys,
    abCheck,
    accountSelect,
    queryAllByOrgId,
    allAccount,
    basictradeList,
    proviceList,
    cityList,
    listTradeByParentId,
    accountServiceList,
    orgList,
    getAllEnumeration,
    settingAccount,
    deleteSaveAccount,
}



// WEBPACK FOOTER //
// ./src/api/account-info/index.js